<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <tabela
          :items="items"
          :loading="loading"
          @rechargeTable="getAll()"
          @switchProcessamentosExpirados="((processamentosExpirados = $event), getAll())"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import SaneamentosRazaoService from '@/services/SaneamentosRazaoService';
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    components: {
      Tabela: () => import('@/components/saneamentoRazao/Tabela.vue')
    },
    mixins: [pusherMixins],

    data: () => ({
      items: [],
      loading: false,
      processamentosExpirados: false
    }),

    mounted() {
      this.subscribe();
      this.getAll();
    },

    methods: {
      subscribe() {
        this.pusherChannel.bind('reload-pag-saneamento-razao', () => {
          this.getAll();
        });
      },

      getAll() {
        this.loading = true;

        SaneamentosRazaoService.getAll(this.processamentosExpirados)
          .then((response) => {
            this.items = response.data.data.map((item) => {
              return {
                ...item,
                sort_versao: `${item.ano.toString().padStart(4, '0')}-${item.mes.toString().padStart(2, '0')}-${item.versao.toString().padStart(3, '0')}`
              };
            });
          })
          .catch((error) => {
            console.error(error);
            this.$toast.error('Erro ao recuperar os Saneamentos do Razão', '', {
              position: 'topRight'
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  };
</script>
